import { Trans, useLingui } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";

import { CopyButton } from "../../../components/ui-kit/copy-button";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "../../../components/ui-kit/dialog";
import { PPGQuickLook } from "../../../models/quick-look-analyses";

export const PPGShareDialog = observer(function PPGShareDialog(props: {
  ppgQuickLook: PPGQuickLook;
}) {
  const { t } = useLingui();
  return (
    <Dialog
      open={props.ppgQuickLook.sharePopupOpen}
      onOpenChange={(open) => {
        if (!open) props.ppgQuickLook.sharePopupOpen = false;
      }}
    >
      <DialogHeader>
        <Trans>
          Share <em>QuickLook</em> analysis.
        </Trans>
      </DialogHeader>
      <DialogBody className="flex flex-col gap-4">
        <p>
          <Trans>
            This link is valid for <strong>1 hour</strong>.
          </Trans>
        </p>
        <p>
          <a
            href={props.ppgQuickLook.sharedAnalysisUrl}
            className="truncate inline-block max-w-[300px]"
            target="_blank"
            rel="noreferrer"
          >
            {props.ppgQuickLook.sharedAnalysisUrl}
          </a>
        </p>
      </DialogBody>
      <DialogFooter>
        <CopyButton
          variant="primary"
          value={props.ppgQuickLook.sharedAnalysisUrl}
          label={t`Copy Link`}
          copiedLabel={t`Link Copied!`}
        />
      </DialogFooter>
    </Dialog>
  );
});
